export enum Duration {
  Week, Month, Year
}
